export const drawerInitialState = {
  open: false
};

export const drawerActions = {
  TOGGLE: (state: any, payload: any) => ({ ...state, open: !state.open })
};

export default {};
